import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Calendar = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M14 2C14.5523 2 15 2.44772 15 3V5H25V3C25 2.44772 25.4477 2 26 2C26.5523 2 27 2.44772 27 3V5H30C32.7614 5 35 7.23858 35 10V30C35 32.7614 32.7614 35 30 35H10C7.23858 35 5 32.7614 5 30V10C5 7.23858 7.23858 5 10 5H13V3C13 2.44772 13.4477 2 14 2ZM13 7H10C8.34315 7 7 8.34315 7 10V16H33V10C33 8.34315 31.6569 7 30 7H27V9C27 9.55228 26.5523 10 26 10C25.4477 10 25 9.55228 25 9V7H15V9C15 9.55228 14.5523 10 14 10C13.4477 10 13 9.55228 13 9V7ZM33 18H7V30C7 31.6569 8.34315 33 10 33H30C31.6569 33 33 31.6569 33 30V18Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Calendar;
